<template>
  <div :class="`p-4 plugin-list ${viewType}`">
    <CRow class="mb-3">
      <CCol class="view-as">
        View as <a @click="e => setView(e, 'list')" href="#">List</a> | <a @click="e => setView(e, 'grid')" href="#">Grid</a>
      </CCol>
    </CRow>
    <template v-if="viewType === 'list'">
      <c-row v-for="(plugin, index) in plugins" :key="index" class="py-2 plugin-row">
        <c-col class="plugin-image" sm="1">
          <img v-lazy="getPluginThumbUrlFromObject(plugin)" class="screenshot" />
        </c-col>
        <c-col class="plugin-name" sm="6">
          <router-link
            :to="{ name: 'pluginDetails', params: { pluginKey: plugin.pluginKey } }"
            v-html="plugin.name"
          ></router-link>
        </c-col>
        <c-col class="plugin-notes" sm="1"></c-col>
        <c-col class="plugin-plugins" sm="4">
          <span class="mt-2 d-block float-right">
            <pill :value="plugin.installCount" />
          </span>
        </c-col>
      </c-row>
    </template>

    <template v-else>
      <c-row class="py-2 plugin-row">
        <c-col v-for="(plugin, index) in plugins" :key="index" class="plugin-image mb-3" sm="6" md="4" lg="3" xl="2">
          <c-card>
            <router-link :to="{ name: 'pluginDetails', params: { pluginKey: plugin.pluginKey } }">
              <c-card-img :src="getPluginThumbUrlFromObject(plugin)"/>
            </router-link>
            <c-card-body>
              <c-card-title style="font-size: 1rem">
                <router-link
                    :to="{ name: 'pluginDetails', params: { pluginKey: plugin.pluginKey } }"
                    v-html="plugin.name"
                    class="text-truncate"
                    style="display: inline-block; max-width: 100%"
                />
              </c-card-title>
            </c-card-body>
            <c-card-footer>
              <span>Installations <strong>{{ plugin.installCount }}</strong></span>
            </c-card-footer>
          </c-card>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { freeSet } from '@coreui/icons';
import VueLazyload from 'vue-lazyload';
import Pill from './Pill';
import { getPluginThumbUrlFromObject } from '@/libs/plugin/getPluginThumbUrlFromObject';

const placeholderImage = process.env.VUE_APP_PLUGIN_PLACEHOLDER_IMAGE_URL;
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholderImage,
  loading: placeholderImage,
  attempt: 1,
});

export default {
  name: 'PluginList',
  components: {
    Pill,
  },
  props: {
    plugins: Array,
    readOnly: Boolean,
    hideHeader: Boolean,
    noBox: Boolean,
    showOnlyRequireUpdates: Boolean,
    viewTypeDefault: String,
  },
  data() {
    return {
      showWpUpdateAllPluginsModal: false,
      error: null,
      filterSites: null,
      freeSet,
      viewType: 'list',
      wpUpdateAllPluginsMessage: '',
      siteToUpdate: null,
    };
  },
  created() {
    this.viewType = this.viewTypeDefault || 'list';
  },
  mounted() {},
  methods: {
    setView(e, type) {
      e.preventDefault();
      this.viewType = type;
    },
    getPluginThumbUrlFromObject,
  },
};
</script>

<style lang="scss" scoped="">
.view-as {
  font-size: 14px;
  a {
    font-weight: bold;
    font-size: inherit;
  }
}

.c-dark-theme {
  .plugin-list {
    background-color: #23242d;
    &.list {
      .plugin-row {
        border-bottom: 1px solid #333;
      }
    }
    &.grid {
      .plugin-name {
        color: white;
      }
    }
  }
}

.plugin-list {
  @media (min-width: 1200px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
  @media (min-width: 1600px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 16.66667%;
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
  @media (min-width: 2200px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 12%;
      flex: 0 0 12%;
      max-width: 12%;
    }
  }
  font-size: 12px;
  &.list {
    .plugin-row {
      border-bottom: 1px solid #eee;
    }
    .plugin-name {
      font-weight: bold;
      .plugin-link {
        font-weight: normal;
      }
    }
    .plugin-notes {
      & > span {
        cursor: pointer;
      }
    }
    .screenshot {
      width: 50px;
      &.no-image {
        opacity: 0.5;
      }
    }
  }
  &.grid {
    .card-img {
      padding: 20%;
    }
    .update-count {
      position: absolute;
      right: 30px;
      top: 0;
    }
    .screenshot {
      width: 90%;
      &:hover {
        outline: 1px solid #00d1b2;
      }
      &.no-image {
        opacity: 0.5;
      }
    }
    .plugin-name-wrapper {
      margin-bottom: 10px;
      min-height: 50px;
      height: 50px;
      position: relative;
    }
    .plugin-name {
      font-weight: bold;
      font-size: 12px;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
